// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"b99e57db","279":"ca2b4bb6","384":"8e20225a","402":"1cfaec04","423":"9e563808","453":"bccc2d7c","513":"9ac978c9","698":"18a733a6"}[chunkId] + ".chunk.js";
};